export default "__VITE_ASSET__32f9c8e8__"